import {Form, Drawer,Button } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
const tailLayout = {
    wrapperCol: { offset: 4, span: 16 },
  };
const Remarks = ({placement,visible,fnc,id, delFnc, refresh, title, btn}) => {
    const onFinish = async (values) => {
        const code = await delFnc(id,values);
        if(code === 201 ){
            refresh()
            fnc()
          }
};

const onFinishFailed = (errorInfo) => {
console.log('Failed:', errorInfo);
};
    return ( 

        <Drawer
              title={title ? title :"Why you want to delete ?"}
              placement={placement}
              closable={false}
              onClose={fnc}
              visible={visible}
              key={placement}
              height={250}
            >
              <Form
            name="basic"
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            style={{alignSelf: 'center'}}
            requiredMark={false}
          >
              <Form.Item
              
                  label={<label style={{whiteSpace: 'normal'}}>Remark</label>}
                  name="remark"
                  rules={[{ required: true, message: 'Remark is required' },]}
                  
                  >
                  <TextArea rows={4} />
              </Form.Item>
              <Form.Item {...tailLayout}> 
                <Button type="primary" htmlType="submit">
                  {btn?btn:'Delete'}
                </Button>
              </Form.Item>
              </Form>
            </Drawer>
     );
}
{/* <Remarks placement={placement} visible={visible} fnc={this.onClose} id={id} delFnc = {deleteRole} /> */}
 
export default Remarks;